/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useState, useEffect} from "react";

import useTypedSelector from "@Services/Hooks/UseTypedSelector";


import ApplicationApiContext from "@Contexts/Api";


import {Col, Row} from "react-bootstrap";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import REST_API_REQUEST from "@Services/Utilities/Requests";


import TransportDocumentComponent from "@UIPages/Authenticated/Settings/User/MyFinishedTransports/TransportsList/Transport/Documents/List/Document";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";

import HTTP_ERROR_RESPONSE_INTERFACE from "@Services/Interfaces/Http/Response/Error";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";

import TRANSPORT_INTERFACE from "@Services/Application/Interfaces/Transports/Transport";
import DOCUMENT_INTERFACE from "@Services/Application/Interfaces/Documents/Document";



type TransportDocumentsListProps = {
    TRANSPORT: TRANSPORT_INTERFACE;
};


export const TransportDocumentsListComponent: React.FC<TransportDocumentsListProps> = ({
    TRANSPORT
}): JSX.Element | null => {


    /** @const {UserInterface | null} Application Logged User (from Global Store Object) */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;

    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [TRANSPORT_DOCUMENTS_LIST, SET_TRANSPORT_DOCUMENTS_LIST] = useState<DOCUMENT_INTERFACE[] | null>(null);
    const [TRANSPORT_DOCUMENTS_ERROR, SET_TRANSPORT_DOCUMENTS_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    useEffect(() => {

        if (!LOGGED_USER?.userID || !REST_API_URL || !TRANSPORT.TransportNo) return;

        const TRANSPORT_DOCUMENTS_API_URL = `${REST_API_URL}/Transport/Get/Docs`;

        const TRANSPORT_DOCUMENTS_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID,
            TransportNo: TRANSPORT.TransportNo
        };

        const GET_TRANSPORT_DOCUMENTS = async (): Promise<void> => {

            try {

                const TRANSPORT_DOCUMENTS_RESPONSE = await REST_API_REQUEST(
                    TRANSPORT_DOCUMENTS_API_URL,
                    TRANSPORT_DOCUMENTS_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (TRANSPORT_DOCUMENTS_RESPONSE.status === 200) {
                    const RESPONSE_TEXT: any = await TRANSPORT_DOCUMENTS_RESPONSE.text();
                    if (RESPONSE_TEXT.trim()) {
                        const RESPONSE_CONTENT: DOCUMENT_INTERFACE[] = JSON.parse(RESPONSE_TEXT).Docs;
                        SET_TRANSPORT_DOCUMENTS_LIST(RESPONSE_CONTENT);
                    } else {
                        SET_TRANSPORT_DOCUMENTS_LIST([]);
                    }
                } else {
                    const RESPONSE_CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await TRANSPORT_DOCUMENTS_RESPONSE.json();
                    SET_TRANSPORT_DOCUMENTS_ERROR({ErrorCode: TRANSPORT_DOCUMENTS_RESPONSE.status, UserMessage: RESPONSE_CONTENT.UserMessage})
                }

            } catch (e) {
                SET_TRANSPORT_DOCUMENTS_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

        };

        GET_TRANSPORT_DOCUMENTS();

    }, [TRANSPORT]);


    useEffect(() => {
        return () => {
            SET_TRANSPORT_DOCUMENTS_LIST(null);
            SET_TRANSPORT_DOCUMENTS_ERROR(null);
        };
    }, []);

    if (!TRANSPORT) return null;


    const TransportDocumentsList = TRANSPORT_DOCUMENTS_LIST?.map((DOCUMENT, i: number) =>
        <TransportDocumentComponent key={i} DOCUMENT={DOCUMENT} />
    );


    return (
        <Col xs={12} className={"finished-transport-documents-list-component finished-transport-documents-list"}>
            <Row className={"finished-transport-documents-list-content"}>

                {!!TRANSPORT_DOCUMENTS_ERROR && <ErrorMessageComponent messageText={TRANSPORT_DOCUMENTS_ERROR.UserMessage} />}

                {!!TRANSPORT_DOCUMENTS_LIST &&

                    TRANSPORT_DOCUMENTS_LIST.length < 1 ?

                    <Col xs={12} className={"no-list-elements-message default-system-message no-documents-message"}>
                        <span>{`Brak dokumentów`}</span>
                    </Col>

                    :

                    TransportDocumentsList

                }

            </Row>
        </Col>
    );

};


export default TransportDocumentsListComponent;
